import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 8, md: 16 }, flex: 1, display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", textAlign: "center" }}>
        <Stack spacing={3} alignItems="center">
          <ErrorOutlineRoundedIcon sx={{ fontSize: 80, color: "secondary.main", opacity: 0.8 }} />
          
          <Box>
            <Typography variant="h6" color="secondary.main" fontWeight={600} sx={{ mb: 1 }}>
              {t("notFound.subtitle")}
            </Typography>
            <Typography variant="h2" sx={{ mb: 2 }}>
              {t("notFound.title")}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400, mx: "auto" }}>
              {t("notFound.message")}
            </Typography>
          </Box>

          <Box sx={{ pt: 2 }}>
            <Button
              component={RouterLink}
              to="/"
              variant="contained"
              color="primary"
              size="large"
            >
              {t("notFound.backToHome")}
            </Button>
          </Box>
        </Stack>
      </Box>
    </Container>
  );
}
